<template>
 <div class="cont">
   <div v-if="isCutCrm3==1">
     <!-- 车队长 -->
      <div v-if="userType==3">
        <div class="addressBox">
            <h4 class="title">
              <span><i class="fa fa-tag iconFont" aria-hidden="true"></i>注册信息</span>
            </h4>
            <div class="box1">
              <div class="item"><span>手机号：</span>{{registerInfo.mobile}}</div>
              <div class="item"><span>注册时间：</span>{{registerInfo.createTime | dateFormat}}</div>
            </div>
        </div>
        <div class="addressBox">
            <h4 class="title">
              <span><i class="fa fa-tag iconFont" aria-hidden="true"></i>认证信息</span>
            </h4>
            <div class="box1">
              <div class="item"><span>队长姓名：</span>{{registerInfo.legalPerson}}</div>
              <div class="item"><span>身份证号：</span>{{registerInfo.legalIdentityCard}}</div>
              <div class="item"><span>联系电话：</span>{{registerInfo.mobile}}</div>
              <div class="item"><span>审核状态：</span>{{["待审核", "审核通过", "审核未通过" ][registerInfo.auditStatus-1]}}</div>
            </div>
        </div>
        <div class="addressBox" >
            <h4 class="title">
              <span><i class="fa fa-tag iconFont" aria-hidden="true"></i>证件照片</span>
            </h4>
            <div>
            <ul class="ul" >
              <li  v-for="(item,index) in srcList"  :key="index">
                <el-image
                  fit="cover"
                  style="width: 150px; height: 150px"
                  :src="item"
                  :preview-src-list="getSrcList(index)"
                >
                </el-image>
              </li>
            </ul>
            <ul class="ul2" >
              <li v-if="registerInfo.legalPersonpic1 !=''">身份证正面</li>
              <li v-if="registerInfo.legalPersonpic2 !=''">身份证背面</li>
            </ul>
            </div>
        </div>
        <div class="addressBox" >
          <h4 class="title">
              <span><i class="fa fa-tag iconFont" aria-hidden="true"></i>专属二维码</span>
          </h4>
          <div>
            <qriously :value="initQCode" :size="138" />
          </div>
        </div>
      </div>
      <!-- 租户 货主车队 -->
      <div v-else>
         <div class="addressBox">
            <h4 class="title">
              <span><i class="fa fa-tag iconFont" aria-hidden="true"></i>认证信息</span>
            </h4>
            <div class="box1">
              <div class="item"><span>企业名称：</span>{{registerInfo.companyName}}</div>
              <div class="item" ><span>营业执照号：</span>{{registerInfo.taxpayerNumber}}</div>
              <!-- <div class="item" ><span>道路运输经营许可证号：</span>{{registerInfo.transPermitno}}</div> -->
              <div class="item"><span>法人姓名：</span>{{registerInfo.legalPerson}}</div>
              <div class="item"><span>身份证号：</span>{{registerInfo.legalIdentityCard}}</div>
              <div class="item"><span>身份证有效期：</span>{{registerInfo.legalIsLong==1?'长期':formatter(registerInfo.legalPersonidValidity,'yyyy-MM-dd') }}</div>
              <div class="item"><span>联系人：</span>{{registerInfo.contactsName}}</div>
              <div class="item"><span>联系电话：</span>{{registerInfo.contactsMoblie}}</div>
            </div>
        </div>
         <div class="addressBox" >
            <h4 class="title">
              <span><i class="fa fa-tag iconFont" aria-hidden="true"></i>证件照片</span>
            </h4>
            <div>
            <ul class="ul" >
              <li  v-for="(item,index) in srcList"  :key="index">
                <el-image
                  fit="cover"
                  style="width: 150px; height: 150px"
                  :src="item"
                  :preview-src-list="getSrcList(index)"
                >
                </el-image>
              </li>
            </ul>
            <ul class="ul2">
              <li v-if="registerInfo.legalPersonpic1 !=''">身份证正面</li>
              <li v-if="registerInfo.legalPersonpic2 !=''">身份证背面</li>
              <li v-if="registerInfo.bsnsLicensepic != ''">营业执照</li>
            </ul>
            </div>
        </div>
      </div>
   </div>
   <div v-else>
    <div class="addressBox">
        <h4 class="title">
          <span><i class="fa fa-tag iconFont" aria-hidden="true"></i>注册信息</span>
        </h4>
        <div class="box1">
          <div class="item"><span>手机号：</span>{{user.userAccount}}</div>
          <div class="item"><span>业务类型：</span>{{businessFlg}}</div>
          <div class="item"><span>注册时间：</span>{{registerInfo.createTime | dateFormat}}</div>
        </div>
    </div>
    <div class="addressBox">
        <h4 class="title">
          <span><i class="fa fa-tag iconFont" aria-hidden="true"></i>认证信息</span>
        </h4>
        <div class="box1">
          <div class="item" v-if="registerInfo.businessFlg != '3'"><span>企业名称：</span>{{registerInfo.companyName}}</div>
          <div class="item" v-if="registerInfo.businessFlg == '3'"><span>队长姓名：</span>{{registerInfo.legalPerson}}</div>
          <div class="item" v-if="registerInfo.businessFlg != '3'"><span>营业执照号：</span>{{registerInfo.bsnsLicenseno}}</div>
          <div class="item" v-if="registerInfo.businessFlg == '2'"><span>道路运输经营许可证号：</span>{{registerInfo.transPermitno}}</div>
          <div class="item" v-if="registerInfo.businessFlg != '3'"><span>审核状态：</span>{{zzauditStatus}}</div>
          <div class="item" v-if="registerInfo.businessFlg != '3'"><span>法人姓名：</span>{{registerInfo.legalPerson}}</div>
          <div class="item"><span>身份证号：</span>{{registerInfo.legalPersonId}}</div>
          <div class="item" v-if="registerInfo.businessFlg != '3'"><span>身份证有效期：</span>{{formatter(registerInfo.personidValidity,'yyyy-MM-dd') }}</div>
          <div class="item"><span>联系人：</span>{{registerInfo.contractName}}</div>
          <div class="item"><span>联系电话：</span>{{registerInfo.contractPhone}}</div>
        </div>
    </div>
    <div class="addressBox" v-if="registerInfo.businessFlg == '1'">
        <h4 class="title">
          <span><i class="fa fa-tag iconFont" aria-hidden="true"></i>证件照片</span>
        </h4>
        <div>
          <ul class="ul" >
            <li  v-for="(item,index) in srcList"  :key="index">
            <el-image
              fit="cover"
              style="width: 150px; height: 150px"
              :src="item"
              :preview-src-list="getSrcList(index)"
            >
            </el-image>
          </li>
          <!-- <li  v-if="registerInfo.legalPersonpic1 !=''">
              <img :src="registerInfo.legalPersonpic1" preview="1">
          </li>
          <li  v-if="registerInfo.legalPersonpic2 !=''">
              <img :src="registerInfo.legalPersonpic2" preview="2">
          </li>
          <li  v-if="registerInfo.bsnsLicensepic != '' && registerInfo.bsnsOneness == '0'">
              <img :src="registerInfo.bsnsLicensepic" preview="3">
          </li>
          <li  v-if="registerInfo.businessLicensepic != '' && registerInfo.bsnsOneness == '1'">
              <img :src="registerInfo.businessLicensepic" preview="4">
          </li>
          <li  v-if="registerInfo.taxOrgcodepic != '' && registerInfo.bsnsOneness == '1'">
              <img :src="registerInfo.taxOrgcodepic" preview="5">
          </li>
          <li  v-if="registerInfo.taxRegistrapic != '' && registerInfo.bsnsOneness == '1'">
              <img :src="registerInfo.taxRegistrapic" preview="6">
          </li> -->
        </ul>
        <ul class="ul2">
          <li v-if="registerInfo.legalPersonpic1 !=''">身份证正面</li>
          <li v-if="registerInfo.legalPersonpic2 !=''">身份证背面</li>
          <li v-if="registerInfo.bsnsLicensepic != '' && registerInfo.bsnsOneness == '0'">营业执照</li>
          <li v-if="registerInfo.businessLicensepic != '' && registerInfo.bsnsOneness == '1'">营业执照</li>
          <li v-if="registerInfo.taxOrgcodepic != '' && registerInfo.bsnsOneness == '1'">组织机构代码</li>
          <li v-if="registerInfo.taxRegistrapic != '' && registerInfo.bsnsOneness == '1'">税务登记证</li>
        </ul>
        </div>
    </div>
    <div class="addressBox" v-if="registerInfo.businessFlg == '2'">
        <h4 class="title">
          <span><i class="fa fa-tag iconFont" aria-hidden="true"></i>证件照片</span>
        </h4>
        <div>
        <ul class="ul" >
          <li  v-for="(item,index) in srcList2"  :key="index">
            <el-image
              fit="cover"
              style="width: 150px; height: 150px"
              :src="item"
              :preview-src-list="getSrcList2(index)"
            >
            </el-image>
          </li>
          <!-- <li  v-if="registerInfo.legalPersonpic1 !=''">
              <img :src="registerInfo.legalPersonpic1" preview="1">
          </li>
          <li  v-if="registerInfo.legalPersonpic2 !=''">
              <img :src="registerInfo.legalPersonpic2" preview="2">
          </li>
          <li  v-if="registerInfo.bsnsLicensepic != '' && registerInfo.bsnsOneness == '0'">
              <img :src="registerInfo.bsnsLicensepic" preview="3">
          </li>
          <li  v-if="registerInfo.businessLicensepic != '' && registerInfo.bsnsOneness == '1'">
              <img :src="registerInfo.businessLicensepic"  preview="4">
          </li>
          <li  v-if="registerInfo.taxOrgcodepic != '' && registerInfo.bsnsOneness == '1'">
              <img :src="registerInfo.taxOrgcodepic" preview="5">
          </li>
          <li  v-if="registerInfo.taxRegistrapic != '' && registerInfo.bsnsOneness == '1'">
              <img :src="registerInfo.taxRegistrapic" preview="6">
          </li>
          <li  v-if="registerInfo.transPermitpic1 != ''">
              <img :src="registerInfo.transPermitpic1" preview="7">
          </li> -->
        </ul>
        <ul class="ul2" v-if="registerInfo.businessFlg == '2'">
          <li v-if="registerInfo.legalPersonpic1 !=''">身份证正面</li>
          <li v-if="registerInfo.legalPersonpic2 !=''">身份证背面</li>
          <li v-if="registerInfo.bsnsLicensepic != '' && registerInfo.bsnsOneness == '0'">营业执照</li>
          <li v-if="registerInfo.businessLicensepic != '' && registerInfo.bsnsOneness == '1'">营业执照</li>
          <li v-if="registerInfo.taxOrgcodepic != '' && registerInfo.bsnsOneness == '1'">组织机构代码</li>
          <li v-if="registerInfo.taxRegistrapic != '' && registerInfo.bsnsOneness == '1'">税务登记证</li>
          <li v-if="registerInfo.transPermitpic1 != ''">道路运输经营许可证</li>
        </ul>
        </div>
    </div>
    <div class="addressBox" v-if="registerInfo.businessFlg == '3'">
        <h4 class="title">
          <span><i class="fa fa-tag iconFont" aria-hidden="true"></i>证件照片</span>
        </h4>
        <div>
        <ul class="ul" >
          <li  v-for="(item,index) in srcList3"  :key="index">
            <el-image
              fit="cover"
              style="width: 150px; height: 150px"
              :src="item"
              :preview-src-list="getSrcList3(index)"
            >
            </el-image>
          </li>
        </ul>
        <ul class="ul2" v-if="registerInfo.businessFlg == '2'">
          <li v-if="registerInfo.legalPersonpic1 !=''">身份证正面</li>
          <li v-if="registerInfo.legalPersonpic2 !=''">身份证背面</li>
          <li v-if="registerInfo.bsnsLicensepic != '' && registerInfo.bsnsOneness == '0'">营业执照</li>
          <li v-if="registerInfo.businessLicensepic != '' && registerInfo.bsnsOneness == '1'">营业执照</li>
          <li v-if="registerInfo.taxOrgcodepic != '' && registerInfo.bsnsOneness == '1'">组织机构代码</li>
          <li v-if="registerInfo.taxRegistrapic != '' && registerInfo.bsnsOneness == '1'">税务登记证</li>
          <li v-if="registerInfo.transPermitpic1 != ''">道路运输经营许可证</li>
        </ul>
        </div>
    </div>
    <div class="addressBox">
      <h4 class="title">
          <span><i class="fa fa-tag iconFont" aria-hidden="true"></i>认证信息</span>
      </h4>
      <p class="status">审核状态：<span>{{zzauditStatus}}</span></p>
      <p class="status" v-if="this.zzauditStatus=='审核未通过'">审核意见：<span>{{registerInfo.nopassReason}}</span></p>
      <!-- v-if="this.registerInfo == undefined &&   -->
      <el-button class="status" type="primary" size='mini' @click="authenticationClick" v-if="registerBtn && btnFlg[1]" btnCode="000P00YB002">再次认证</el-button>
      <!-- <el-button class="status" type="primary" size='mini' @click="authenticationClick" v-if="changeBtn && btnFlg[0]" btnCode="000P00YB001">修改认证信息</el-button> -->
    </div>
    <!-- 二维码 -->
    <div class="addressBox" v-if="registerInfo.businessFlg == '3'">
      <h4 class="title">
          <span><i class="fa fa-tag iconFont" aria-hidden="true"></i>专属二维码</span>
      </h4>
      <div>
        <qriously :value="initQCode" :size="138" />
      </div>
    </div>
   </div>
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { getUserDetail } from '@/api/consignment'
import { sCompanyCaptainBeanByUserId, sTenantGetTenantDetailByCode } from '@/api/newCrm'
import { encryption } from '@/utils/util'

export default {
  data () {
    return {
      // 按钮
      btnFlg: [],
      btnIdArr: ['000P00YB001', '000P00YB002'],
      registerInfo: {},
      businessFlg: '',
      zzauditStatus: '',
      user: {},
      registerBtn: false,
      changeBtn: false,
      boHui: false,
      srcList: [],
      srcList2: [],
      srcList3: [],
      initQCode: '',
      isCutCrm3: localStorage.getItem('isCutCrm3'),
      userType: localStorage.getItem('userType')// 1、平台自有用户 2、租户用户，3.平台挂靠车队长，4.平台挂靠司机
    }
  },
  created () {
    if (this.isCutCrm3 == 1) {
      this.getUserInfoV2()
    } else {
      this.getUserInfo()
    }

    this.btnFlg = getBtn(this.btnIdArr, '/systemManagement/enterprise')
  },
  mounted () {

  },
  methods: {
    getUserInfoV2 () {
      if (this.userType == 3) {
        sCompanyCaptainBeanByUserId({ userId: localStorage.getItem('registerId') }).then(res => {
          this.registerInfo = res
          let id = '' + localStorage.getItem('registerId')
          let name = this.registerInfo.legalPerson
          let isCutCrm3 = this.isCutCrm3
          let json = {
            id: id,
            name: name,
            isCutCrm3: isCutCrm3
          }
          let data = encryption({
            data: json,
            key: this.global.key,
            param: ['id', 'name']
          })
          this.initQCode = JSON.stringify(data)
          this.user = res.user
          this.srcList = []
          if (this.registerInfo.legalPersonpic1 != '') {
            this.srcList.push(this.registerInfo.legalPersonpic1Url)
          }
          if (this.registerInfo.legalPersonpic2 != '') {
            this.srcList.push(this.registerInfo.legalPersonpic2Url)
          }
        }).catch(err => {
          this.$message.error(err.message)
        })
      } else {
        sTenantGetTenantDetailByCode({ tenantCode: localStorage.getItem('tenantCode') }).then(res => {
          this.registerInfo = res
          if (this.registerInfo.legalPersonpic1 != '') {
            this.srcList.push(this.registerInfo.legalPersonpic1Url)
          }
          if (this.registerInfo.legalPersonpic2 != '') {
            this.srcList.push(this.registerInfo.legalPersonpic2Url)
          }
          if (this.registerInfo.bsnsLicensepicUrl != '') {
            this.srcList.push(this.registerInfo.bsnsLicensepicUrl)
          }
        }).catch(err => {
          this.$message.error(err.message)
        })
      }
    },
    // 二维码支持中文
    utf16to8 (str) {
      var out, i, len, c
      out = ''
      len = str.length
      for (i = 0; i < len; i++) {
        c = str.charCodeAt(i)
        if ((c >= 0x0001) && (c <= 0x007F)) {
          out += str.charAt(i)
        } else if (c > 0x07FF) {
          out += String.fromCharCode(0xE0 | ((c >> 12) & 0x0F))
          out += String.fromCharCode(0x80 | ((c >> 6) & 0x3F))
          out += String.fromCharCode(0x80 | ((c >> 0) & 0x3F))
        } else {
          out += String.fromCharCode(0xC0 | ((c >> 6) & 0x1F))
          out += String.fromCharCode(0x80 | ((c >> 0) & 0x3F))
        }
      }
      return out
    },
    getUserInfo () {
      getUserDetail().then(res => {
        if (res.registerInfo != undefined) {
          this.registerInfo = res.registerInfo
          let id = '' + this.registerInfo.id
          let name = this.registerInfo.legalPerson
          let json = {
            id: id,
            name: name
          }
          let data = encryption({
            data: json,
            key: this.global.key,
            param: ['id', 'name']
          })
          this.initQCode = JSON.stringify(data)
          // this.initQCode = this.utf16to8('{' + '"id":' + id + ',' + '"name":"' + name + '"}')
          this.user = res.user
          this.srcList = []
          if (this.registerInfo.legalPersonpic1 != '') {
            this.srcList.push(this.registerInfo.legalPersonpic1)
          }
          if (this.registerInfo.legalPersonpic2 != '') {
            this.srcList.push(this.registerInfo.legalPersonpic2)
          }
          if (this.registerInfo.bsnsLicensepic != '' && this.registerInfo.bsnsOneness == '0') {
            this.srcList.push(this.registerInfo.bsnsLicensepic)
          }
          if (this.registerInfo.businessLicensepic != '' && this.registerInfo.bsnsOneness == '1') {
            this.srcList.push(this.registerInfo.businessLicensepic)
          }
          if (this.registerInfo.taxOrgcodepic != '' && this.registerInfo.bsnsOneness == '1') {
            this.srcList.push(this.registerInfo.taxOrgcodepic)
          }
          if (this.registerInfo.taxRegistrapic != '' && this.registerInfo.bsnsOneness == '1') {
            this.srcList.push(this.registerInfo.taxRegistrapic)
          }
          this.srcList2 = []
          if (this.registerInfo.legalPersonpic1 != '') {
            this.srcList2.push(this.registerInfo.legalPersonpic1)
          }
          if (this.registerInfo.legalPersonpic2 != '') {
            this.srcList2.push(this.registerInfo.legalPersonpic2)
          }
          if (this.registerInfo.bsnsLicensepic != '' && this.registerInfo.bsnsOneness == '0') {
            this.srcList2.push(this.registerInfo.bsnsLicensepic)
          }
          if (this.registerInfo.businessLicensepic != '' && this.registerInfo.bsnsOneness == '1') {
            this.srcList2.push(this.registerInfo.businessLicensepic)
          }
          if (this.registerInfo.transPermitpic1 != '') {
            this.srcList2.push(this.registerInfo.transPermitpic1)
          }
          if (this.registerInfo.taxOrgcodepic != '' && this.registerInfo.bsnsOneness == '1') {
            this.srcList2.push(this.registerInfo.taxOrgcodepic)
          }
          if (this.registerInfo.taxRegistrapic != '' && this.registerInfo.bsnsOneness == '1') {
            this.srcList2.push(this.registerInfo.taxRegistrapic)
          }
          this.srcList3 = []
          if (this.registerInfo.legalPersonpic1 != '') {
            this.srcList3.push(this.registerInfo.legalPersonpic1)
          }
          if (this.registerInfo.legalPersonpic2 != '') {
            this.srcList3.push(this.registerInfo.legalPersonpic2)
          }
          if (this.registerInfo.transPermitpic1 != '') {
            this.srcList3.push(this.registerInfo.transPermitpic1)
          }
          if (this.registerInfo.transPermitpic2 != '') {
            this.srcList3.push(this.registerInfo.transPermitpic2)
          }
          this.$previewRefresh()
          if (res.registerInfo.businessFlg == '1') {
            this.businessFlg = '托运业务'
          } else if (res.registerInfo.businessFlg == '2') {
            this.businessFlg = '承运业务'
          } else if (res.registerInfo.businessFlg == '3') {
            this.businessFlg = '车队长业务'
          }
          if (res.registerInfo.zzauditStatus == '1') {
            this.zzauditStatus = '待审核'
          } else if (res.registerInfo.zzauditStatus == '2') {
            this.zzauditStatus = '审核通过'
          } else if (res.registerInfo.zzauditStatus == '3') {
            this.zzauditStatus = '审核未通过'
          }
          // 审核通过得按钮叫修改认证信息   不显示驳回原因
          // 审核未通过的按钮叫再次认证
          // 待审核无按钮显示
          if (this.registerInfo.zzauditStatus == '1') { // 待审核
            this.registerBtn = false // 待审核和审核未通过
            this.changeBtn = false // 修改按钮
          }
          if (this.registerInfo.zzauditStatus == '2') { // 审核通过
            this.boHui = false // 审核通过不显示驳回原因
            this.changeBtn = true // 修改按钮
          }
          if (this.registerInfo.zzauditStatus == '3') { // 审核未通过
            this.registerBtn = true
          }
        } else {
          this.registerBtn = true
        }
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 点击图片放大
    getSrcList (index) {
      return this.srcList.slice(index).concat(this.srcList.slice(0, index))
    },
    // 点击图片放大
    getSrcList2 (index) {
      return this.srcList2.slice(index).concat(this.srcList2.slice(0, index))
    },
    // 点击图片放大
    getSrcList3 (index) {
      return this.srcList3.slice(index).concat(this.srcList3.slice(0, index))
    },
    // 点击再次认证
    authenticationClick () {
      this.$router.push({
        path: '/systemManagement/authentication'
      })
      localStorage.setItem('registerInfo', JSON.stringify(this.registerInfo))
      localStorage.setItem('tenantUnder', this.user.tenantUnder)
    },
    // 时间格式化
    dateFormat: function (row, column, cellValue) {
      var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
        t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      // var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
      // var minutes = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
      // var seconds = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
      return (
        t.getFullYear() + '-' + month + '-' + date
        // +
        // ' ' +
        // hour +
        // ':' +
        // minutes +
        // ':' +
        // seconds
      )
      // return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate(); // 年月日
    },
    // 时间格式化
    formatter (thistime, fmt) {
      let $this = new Date(thistime)
      let o = {
        'M+': $this.getMonth() + 1,
        'd+': $this.getDate(),
        'h+': $this.getHours(),
        'm+': $this.getMinutes(),
        's+': $this.getSeconds(),
        'q+': Math.floor(($this.getMonth() + 3) / 3),
        'S': $this.getMilliseconds()
      }
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, ($this.getFullYear() + '').substr(4 - RegExp.$1.length))
      }
      for (var k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
        }
      }
      return fmt
    }
  }
}
</script>

<style scoped lang='less'>
.cont{
  width: 100%;
}
.box1{
  font-size: 14px;
  display: flex;
 flex-wrap: wrap;
 padding-left: 16px;
 padding-bottom: 16px;
 .item{
   margin-right: 30px;
   margin-bottom: 16px;
   span{
     color: #757272;
   }

 }
}
 .addressBox{
  .ul {
    display: flex;
    // flex-wrap: wrap;
    height: 150px;
    li {
      width: 150px;
      height: 150px;
      border-radius: 20px;
      overflow: hidden;
      border: 1px dashed #ccc;
      margin-right: 30px;
      text-align: center;

      img {
        height: 100%;
        width: 100%;
      }
    }
  }
  .ul2 {
    display: flex;
    // flex-wrap: wrap;
    li {
      width: 150px;
      margin-right: 30px;
      font-size: 14px;
      text-align: center;
    }
  }
}
 .status{
    margin-left: 10px;
  }
</style>
